

























import DataOutput from './DataOutput.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    name: 'memory-stack',
    components: { DataOutput },
    props: {
        itemCount: {
            type: Number,
            required: true,
        },
        data: {
            type: Array as PropType<number[]>,
            required: true,
        },
    },
});
